import { Incidents } from "@/features/incidents/incidents";

export const Route = createFileRoute({
  component: Incidents,
});
